import React, { useRef } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { GARAGE } from "../mock";

const GarageCard = ({ car, index }) => {
  const videoRef = useRef(null);

  const handleEnter = () => {
    const v = videoRef.current;
    if (v) {
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    }
  };
  const handleLeave = () => {
    const v = videoRef.current;
    if (v) v.pause();
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ delay: index * 0.1, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      className="card-lift group relative rounded-2xl overflow-hidden border border-white/8 bg-[#0e0e11] cursor-pointer"
    >
      <div className="relative aspect-[4/5] overflow-hidden">
        <video
          ref={videoRef}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          src={car.src}
          muted
          loop
          playsInline
          preload="metadata"
          autoPlay
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#08080a] via-[#08080a]/20 to-transparent" />
        <div className="absolute top-4 right-4 w-9 h-9 rounded-full glass flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <ArrowUpRight size={16} className="text-[#ff6a00]" />
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-[11px] font-display tracking-[0.2em] uppercase text-[#ff8a4c] mb-1">
            {car.tagline}
          </p>
          <h3 className="font-display font-extrabold text-2xl text-white drop-shadow-lg">
            {car.brand}
          </h3>
        </div>
      </div>
    </motion.div>
  );
};

const Garage = () => {
  return (
    <section id="garage" className="section-pad relative bg-[#08080a] overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mb-16"
        >
          <span className="eyebrow">Le Garage</span>
          <h2 className="section-title text-4xl md:text-6xl text-white mt-5">
            Toutes marques, <span className="racing-text">tous budgets</span>
          </h2>
          <p className="mt-5 text-white/60 text-lg leading-relaxed">
            Citadine, familiale, utilitaire, électrique, premium ou sportive :
            j'importe toutes les marques, pour tous les budgets, depuis l'Europe.
            Voici quelques exemples parmi les véhicules que je vous trouve.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {GARAGE.map((car, i) => (
            <GarageCard key={car.brand} car={car} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Garage;
